import { render, staticRenderFns } from "./NotificationGroupsUpdate.vue?vue&type=template&id=a1ab2e24&"
import script from "./NotificationGroupsUpdate.vue?vue&type=script&lang=js&"
export * from "./NotificationGroupsUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports